<template>
    <footer class="footer d-md-flex flex-row justify-content-center align-items-center">
        <div>
            Copyright © 2020 寬域工作室. <span class="mobile-br">All rights reserved.</span>
        </div>
    </footer>

</template>

<script>
export default {
  name: 'Footer',
  props: {
    msg: String
  },
  mounted () {
    // $(window).scroll(function () {
    //   var scrollVal = $(this).scrollTop()
    //   console.log(scrollVal);
    //   if (scrollVal >= 64) {
    //     $('body').addClass('show-nav')
    //   } else {
    //     $('body').removeClass('show-nav')
    //   }
    // })
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
    .mobile-br
        @media screen and (max-width: 767px)
            display: block
    h6
        a
            font-size: 0.9rem
            color: rgba(0,0,0,0.9)
            &:hover
                text-decoration: none
    li
        list-style: none
        a
            font-size: 16px
            color: rgba(0,0,0,0.9)
            letter-spacing: 0.5px
            @media screen and (max-width: 767px)
                font-size: 20px
            &:hover
                text-decoration: none
    .footer
        background-color: #F2DCE8
        color: rgba(0,0,0,0.7)
        // position: absolute
        // position: fixed
        // position: relative
        // top: 0
        width: 100%
        min-height: 100px
        line-height:100px
        // z-index: 10
        // background-color: #fefefe
        font-size: 14px
        @media screen and (max-width: 767px)
            display: flex
            position: static
            width: 100vw
            background-color: #F2DCE8
            line-height: 1.5em
            &.active
                z-index: 10
                position: fixed
                top: 0

</style>
